export function useImageWithConversions() {
    const getFirstImage = (images, conversion = 'full')=>{

        if (images.length <= 0){
           return null
        }
        
        if(images[0].conversions.length <= 0 ){
            return null
        }

        const conversionImages = images[0].conversions.filter(
            image => image.conversion === conversion
        );

        if(conversionImages.length <= 0){
            return null
        }

        return conversionImages[0].storageUrl
    }
      
    return { getFirstImage };
  }